import { createTheme, Palette } from '@mui/material/styles';
import { IAppTheme } from 'types/theme';
import { applyHslDiff } from './color';
import { createCommonComponentsOverrides } from './componentOverrides';
import { themeBase } from './themeBase';
import { createThemedTypographies } from './typographies';

const createDarkPalette = (
	main: string,
	dark: string,
	light: string,
	highlight: string,
	contrast: string
): Palette => {
	const { palette } = createTheme({
		palette: {
			mode: 'dark',
			appBackground: `linear-gradient(259deg, ${applyHslDiff(main, '#0085FF', '#303F53', { resL: 0.26 })} 0%, ${applyHslDiff(main, '#0085FF', '#283545', { resL: 0.21 })} 24.4%, ${applyHslDiff(main, '#0085FF', '#212E3D', { resL: 0.18 })} 34.4%, #2c2c2c 50%)`,
			mainPaperBackground: '#191919',
			illustrationAccent: applyHslDiff(main, '#0085FF', '#8C9EFF'),
			primary: {
				main,
				dark,
				light,
				highlight,
				contrastText: contrast
			},
			grey: {
				'50': '#FAFAFA',
				'100': '#1F1F1F',
				'200': '#444444',
				'300': '#575757',
				'400': '#A5A5A5',
				'500': '#D7D7D7',
				'600': '#F4F4F4',
				'700': '#FAFAFA',
				'800': '#FDFDFD'
			},
			background: {
				paper: '#212121'
			}
		}
	});

	return palette;
};

const createStyledDarkTheme = (appTheme?: IAppTheme | null) => {
	const { main, dark, light, highlight, contrast } =
		appTheme?.dark?.colors?.primary || {};

	const palette = createDarkPalette(
		main || '#0085FF',
		dark || '#0068C8',
		light || '#2D4255',
		highlight || '#1A2732',
		contrast || '#FFFFFF'
	);

	const theme = createTheme({
		assets: {
			logo: appTheme?.dark.logoUrl,
			favicon: appTheme?.dark.faviconUrl
		},
		...themeBase,
		typography: createThemedTypographies(appTheme?.dark),
		palette,
		components: createCommonComponentsOverrides(palette)
	});

	return theme;
};

export { createStyledDarkTheme };
